import React, { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown/with-html";
import { Container, Row, Col } from "react-bootstrap";
import RemarkMathPlugin from 'remark-math';
import { BlockMath, InlineMath } from 'react-katex';
import CodeBlock from "./CodeBlock";
import 'katex/dist/katex.min.css';
import './styles/BlogMarkdown.scss'


export default function BlogMarkdown(props) {
  const dirName = props.match.params.id;
  const blogPath = `${process.env.PUBLIC_URL}/assets/markdown_blogs/${dirName}/content.md`;
  const [isLoading, setLoading] = useState(true);
  const [markdown, setMarkdown] = useState("");
  const [isError, setError] = useState(false);

  function doesBlogFileExist(responseString){
    // this check works because the fetch api returns the index.html when the blog doesn't exist, idk why.
    // All blogs has <!-- title start --> tag, so when that thing isn't there then the blog file didn't get 
    // fetched and instead we grabbed the index.html
    if (responseString.includes('<!-- title start -->')) {
      return true
    }
  }

  async function loadFile() {
    setLoading(true);
    try {
      let mdString = await fetch(blogPath);
      mdString = await mdString.text();
      //I need this check because the thing renders index.html when I pass a blog id that doesnt exist
      if (doesBlogFileExist(mdString)) {
        setMarkdown(mdString);
      } else {
        setError(true);
      }
      setLoading(false);
    } catch (error) {
      alert("An error has occurred, please go back and try again");
      // setError(true);
      console.log("ERRR");
    }
  }

  useEffect(() => {
    loadFile();
  }, []);

  return (
    <div id="mdBlog">
      {isError ? <div>An Error has occurred check url, or navigate to the required page from the home page</div> : null}
      {isLoading ? (
        <div>Loading...</div>
      ) : (
          <Container>

            <Row className="my-5">
              <Col>
                <ReactMarkdown source={markdown} escapeHtml={false} 
                
                plugins={[RemarkMathPlugin]}

                  renderers={{
                    math: ({ value }) => <BlockMath>{value}</BlockMath>,
                    inlineMath: ({ value }) => <InlineMath>{value}</InlineMath>,
                    code: CodeBlock 
                  }} />

              </Col>
            </Row>
          </Container>
        )}
    </div>
  );
}
